var map = {
	"./card.svg": 2482,
	"./document-white.svg": 1611,
	"./document.svg": 9787,
	"./house.svg": 6060,
	"./key.svg": 1301,
	"./logout.svg": 5338,
	"./password-white.svg": 4715,
	"./password.svg": 7275,
	"./personal-id.svg": 9966,
	"./screw.svg": 4327,
	"./share.svg": 3185,
	"./user.svg": 5881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2512;